import {
  ColumnStyle,
  OrderLabelEnum,
  ShelfPatternEnum,
  ShelfProductPatternEnum,
  ShelfStyleEnum,
  SUBPRODUCT_PRICE_DISPLAY_FORMAT,
} from 'src/interfaces';
import { lang } from 'src/utils';

import { ShelfProductTextAlignmentEnum } from '../../../FormSelector.interface';

export const badgeTypeOptions = [
  { label: '123', value: OrderLabelEnum.number },
  { label: 'abc', value: OrderLabelEnum.alphabet },
];

export const generateBadgeSizeOption = (size: number) => {
  return size >= 0
    ? Array.from(Array(size).keys(), (i) => i + 1).map((i) => ({
        value: i + 'px',
        label: i.toString(),
      }))
    : [];
};

export const generateSelectNumberOptions = (start = 1, end = 150) => {
  return Array.from({ length: end - start + 1 }, (v, i) => ({
    label: (start + i).toString(),
    value: (start + i).toString(),
  }));
};

export const generateAlphabetOptions = () => {
  const startCharCode = 'a'.charCodeAt(0);
  const endCharCode = 'u'.charCodeAt(0);
  const options = [];
  for (let i = startCharCode; i <= endCharCode; i++) {
    options.push({
      label: String.fromCharCode(i),
      value: (i - startCharCode).toString(),
    });
  }

  return options;
};

export const columnStyleOptions = [
  {
    label: lang.continuous,
    value: ColumnStyle.CONTINUOUS,
  },
  {
    label: lang.category,
    value: ColumnStyle.CATEGORY,
  },
];

export const lineupStyleTypeOptions = [
  { label: lang.staggered, value: ShelfStyleEnum.STAGGERED },
  { label: lang.straight, value: ShelfStyleEnum.STRAIGHT },
];

export const lineupStylePatternOptions = [
  { label: '', value: '' },
  { label: lang.firstProductTop, value: ShelfPatternEnum.FROM_TOP },
  {
    label: lang.firstProductBottom,
    value: ShelfPatternEnum.FROM_BOTTOM,
  },
];

export const lineupStyleOrderOptions = [
  { label: lang.default, value: ShelfProductPatternEnum.DEFAULT },
  {
    label: lang.imageBelowText,
    value: ShelfProductPatternEnum.IMAGE_BELOW_TEXT,
  },
];

export const textAlignmentOptions = [
  { label: lang.left, value: ShelfProductTextAlignmentEnum.LEFT },
  { label: lang.right, value: ShelfProductTextAlignmentEnum.RIGHT },
  { label: lang.center, value: ShelfProductTextAlignmentEnum.CENTER },
];

export const lineupStyleOptions = [
  {
    label: lang.none,
    value: SUBPRODUCT_PRICE_DISPLAY_FORMAT.NONE,
  },
  {
    label: lang.inline,
    value: SUBPRODUCT_PRICE_DISPLAY_FORMAT.INLINE,
  },
  {
    label: lang.multiline,
    value: SUBPRODUCT_PRICE_DISPLAY_FORMAT.MULTILINE,
  },
];
